import Vue from 'vue'
import Router from 'vue-router'

import home from '@/views/home'
import homeTop from '@/views/goods/home_top'
import homeCategory from '@/views/goods/home_category'
import category from '@/views/category'
import goods from '@/views/goods'
import navChild from '@/views/goods/navChild'
import cart from '@/views/cart'
import mine from '@/views/mine'
import bomAdd from '@/views/bom/add.vue'
import bomFile from '@/views/bom/file.vue'
import bomImage from '@/views/bom/image.vue'
import purchase from '@/views/purchase'
import purchaseFile from '@/views/purchase/file.vue'
import purchaseImage from '@/views/purchase/image.vue'
import table from '@/views/purchase/table'
import search from '@/views/search'
import product from '@/views/product'
import productShopList from '@/views/product/modules/product_list.vue'
import productNavList from '@/views/product/modules/nav_product_list.vue'
import productBannerList from '@/views/product/modules/banner_product_list.vue'
import searchProduct from '@/views/product/modules/search_product.vue'
import productDetail from '@/views/detail'
import productPdf from '@/views/detail/pdf'
import matter from '@/views/matter'
import addOrder from '@/views/order/add.vue'
import cartBuy from '@/views/order/cartBuy.vue'
import ticket from '@/views/ticket'
import ticketList from '@/views/ticket/list.vue'
import addressAdd from '@/views/address/add.vue'
import addressEdit from '@/views/address/edit.vue'
import addressList from '@/views/address/list.vue'

// 商家入口
import business from '@/views/business'
import businessAgreement from '@/views/business/login/agreement'
import productAdd from '@/views/business/product/add'
import cash from '@/views/business/cash'
import price from '@/views/business/price'
import priceImage from '@/views/business/price/image'
import priceFile from '@/views/business/price/file'
import addProduct from '@/views/business/product/addProduct'
import book from '@/views/business/product/book'
import businessTb from '@/views/business/price/table'

//商家求购
import businessPurchase from '@/views/business/purchase'
import businessPurchaseImage from '@/views/business/purchase/image'
import businessPurchaseFile from '@/views/business/purchase/file'
import businessPurchaseTable from '@/views/business/purchase/table'

// 商家注册
import businessRegister from '@/views/business/login/register'
import businessLogin from '@/views/business/login'
import supplierLogin from '@/views/business/login/supplierLogin'
import clientLogin from '@/views/login/clientLogin'
// 免费入驻 个人
import personal from '@/views/business/settlement/personal'
import store from '@/views/business/settlement/store'
// 商家产品列表
import productList from '@/views/business/product/list'

// 会员中心用户注册
import login from '@/views/login'
import agreement from '@/views/login/agreement'
import register from '@/views/login/register'
import phone from '@/views/login/phone'
import addPhone from '@/views/login/addPhone'

// 我的订单
import order from '@/views/order'
import refund from '@/views/order/refund'
import orderDetails from '@/views/order/details'
import logistics from '@/views/order/logistics'
import logisticsRenGon from '@/views/order/logisticsRenGon'
import refundLogistics from '@/views/mine/refund/logistics'

// 售后/退款
import afterRefund from '@/views/mine/refund/afterRefund'
import writeRefund from '@/views/mine/refund/writeRefund'
import refundDetatils from '@/views/mine/refund/refundDetatils'

// 充值
import mineRecharge from '@/views/mine/mine_recharge'
import detail from '@/views/mine/detail'

// 我的收益
import earnings from '@/views/mine/earnings'
import withdraw from '@/views/mine/withdraw'
import cashDetail from '@/views/mine/cashDetail'

// 我的求购
import myBuy from '@/views/mine/buy/myBuy'
import history from '@/views/mine/buy/history'
import buyImages from '@/views/mine/buy/buyImages'
import showFile from '@/views/mine/buy/showFile'

// 我的发票
import invoice from '@/views/invoice'
import details from '@/views/invoice/details'

// 我的收货地址
import address from '@/views/address'
import edit from '@/views/address/edit'
import addAddr from '@/views/address/add'

// 我的收藏
import collect from '@/views/mine/collect'

// 我的足迹
import track from '@/views/mine/track'

// 商家入驻
import enter from '@/views/mine/enter'
import enterApply from '@/views/mine/enter/apply'

// 联系客服
import service from '@/views/mine/service'

// 成为高级VIP创客
import distribution from '@/views/mine/distribution'

// 优惠券
import coupon from '@/views/mine/coupon'
import myCoupon from '@/views/mine/coupon/myCoupon'
import core from '@/views/mine/coupon/core'

// 会员权益
import interests from '@/views/mine/vip'
import attestation from '@/views/mine/vip/attestation'
import openVip from '@/views/mine/vip/openVip'
import commodity from '@/views/mine/vip/commodity'
import publicList from '@/views/home/modules/publicList'

//用户信息
import editUser from '@/views/mine/user/info'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: [{
    path: '/',
    name: 'home',
    component: home,
    meta: {
      keepAlive: true,
    }
  },
    {
      path: '/publicList',
      name: 'publicList',
      component: publicList
    },
    {
      path: '/business',
      name: 'business',
      component: business
    },
    {
      path: '/business/agreement',
      name: 'businessAgreement',
      component: businessAgreement
    },
    // {
    //   path: '/business/login/register',
    //   name: 'businessRegister',
    //   component: businessRegister
    // },
    // {
    //   path: '/business/login',
    //   name: 'businessLogin',
    //   component: businessLogin
    // },
    {
      path: '/business/supplierLogin',
      name: 'supplierLogin',
      component: supplierLogin
    },

    {
      path: '/business/editProduct',
      name: 'productAdd',
      component: productAdd
    },
    {
      path: '/business/product/list',
      name: 'productList',
      component: productList
    },
    {
      path: '/business/cash',
      name: 'cash',
      component: cash
    },
    {
      path: '/business/price',
      name: 'price',
      component: price
    },
    {
      path: '/business/price/file',
      name: 'priceFile',
      component: priceFile
    },
    {
      path: '/business/price/image',
      name: 'priceImage',
      component: priceImage
    },
    {
      path: '/businessTb',
      name: 'businessTb',
      component: businessTb
    },
    {
      path: '/business/purchase',
      name: 'businessPurchase',
      component: businessPurchase
    },
    {
      path: '/business/purchase/file',
      name: 'businessPurchaseFile',
      component: businessPurchaseFile
    },
    {
      path: '/business/purchase/image',
      name: 'businessPurchaseImage',
      component: businessPurchaseImage
    },
    {
      path: '/business/purchase/table',
      name: 'businessPurchaseTable',
      component: businessPurchaseTable
    },
    {
      path: '/business/addProduct',
      name: 'addProduct',
      component: addProduct
    },
    {
      path: '/business/addProduct/book',
      name: 'book',
      component: book
    },
    {
      path: '/business/settlement/personal',
      name: 'personal',
      component: personal
    },
    {
      path: '/business/settlement/store',
      name: 'store',
      component: store
    },
    {
      path: '/login',
      name: 'clientLogin',
      component: clientLogin
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement
    },
    {
      path: '/phone',
      name: 'phone',
      component: phone
    },
    {
      path: '/addPhone',
      name: 'addPhone',
      component: addPhone
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/homeTop',
      name: 'homeTop',
      component: homeTop,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/homeCategory',
      name: 'homeCategory',
      component: homeCategory,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/category',
      name: 'category',
      component: category
    },
    {
      path: '/goods',
      name: 'goods',
      component: goods,
      meta: {
        keepAlive: true,
      }

    },
    {
      path: '/goods/nav',
      name: 'nav',
      component: navChild
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/bom/add',
      name: 'bomAdd',
      component: bomAdd
    },
    {
      path: '/bom/file',
      name: 'bomFile',
      component: bomFile
    },
    {
      path: '/cashDetail',
      name: 'cashDetail',
      component: cashDetail
    },
    {
      path: '/bom/image',
      name: 'bomImage',
      component: bomImage
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: purchase
    },
    {
      path: '/purchase/file',
      name: 'purchaseFile',
      component: purchaseFile
    },
    {
      path: '/purchase/image',
      name: 'purchaseImage',
      component: purchaseImage
    },
    {
      path: '/purchase/table',
      name: 'table',
      component: table
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/productShopList',
      name: 'productShopList',
      component: productShopList
    },
    {
      path: '/productNavList',
      name: 'productNavList',
      component: productNavList,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/productBannerList',
      name: 'productBannerList',
      component: productBannerList
    },
    {
      path: '/searchProduct',
      name: 'searchProduct',
      component: searchProduct
    },
    {
      path: '/product/detail',
      name: 'productDetail',
      component: productDetail
    },
    {
      path: '/product/pdf',
      name: 'productPdf',
      component: productPdf
    },
    {
      path: '/matter',
      name: 'matter',
      component: matter
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: ticket
    },
    {
      path: '/ticket/list',
      name: 'ticketList',
      component: ticketList
    },
    {
      path: '/order/add',
      name: 'addOrder',
      component: addOrder
    },
    {
      path: '/order/cartBuy',
      name: 'cartBuy',
      component: cartBuy
    },
    {
      path: '/refund',
      name: 'refund',
      component: refund
    },
    {
      path: '/refund/logistics',
      name: 'refundLogistics',
      component: refundLogistics
    },
    {
      path: '/order/details',
      name: 'orderDetails',
      component: orderDetails
    },
    {
      path: '/order/logistics',
      name: 'logistics',
      component: logistics
    },
    {
      path: '/order/logisticsRenGon',
      name: 'logisticsRenGon',
      component: logisticsRenGon
    },
    {
      path: '/mine/refund/afterRefund',
      name: 'afterRefund',
      component: afterRefund
    },
    {
      path: '/mine/refund/writeRefund',
      name: 'writeRefund',
      component: writeRefund
    },
    {
      path: '/mine/refund/refundDetatils',
      name: 'refundDetatils',
      component: refundDetatils
    },
    {
      path: '/address/add',
      name: 'addressAdd',
      component: addressAdd
    },
    {
      path: '/address/edit',
      name: 'addressEdit',
      component: addressEdit
    },
    {
      path: '/address/list',
      name: 'addressList',
      component: addressList
    },
    {
      path: '/mineRecharge',
      name: 'mineRecharge',
      component: mineRecharge
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/earnings',
      name: 'earnings',
      component: earnings
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/edit',
      name: 'edit',
      component: edit
    },
    {
      path: '/addAddr',
      name: 'addAddr',
      component: addAddr
    },
    {
      path: '/collect',
      name: 'collect',
      component: collect
    },
    {
      path: '/track',
      name: 'track',
      component: track
    },
    {
      path: '/enter',
      name: 'enter',
      component: enter
    },
    {
      path: '/enterApply',
      name: 'enterApply',
      component: enterApply
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/distribution',
      name: 'distribution',
      component: distribution
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: coupon
    },
    {
      path: '/myCoupon',
      name: 'myCoupon',
      component: myCoupon

    },
    {
      path: '/core',
      name: 'core',
      component: core
    },
    {
      path: '/mine/buy/myBuy',
      name: 'myBuy',
      component: myBuy
    },
    {
      path: '/mine/buy/history',
      name: 'history',
      component: history
    },
    {
      path: '/mine/buy/buyImages',
      name: 'buyImages',
      component: buyImages
    },
    {
      path: '/mine/buy/showFile',
      name: 'showFile',
      component: showFile
    },
    {
      path: '/mine/vip/interests',
      name: 'interests',
      component: interests
    },
    {
      path: '/mine/vip/attestation',
      name: 'attestation',
      component: attestation
    },
    {
      path: '/mine/vip/openVip',
      name: 'openVip',
      component: openVip
    },
    {
      path: '/mine/vip/commodity',
      name: 'commodity',
      component: commodity
    },
    {
      path: '/mine/editUser',
      name: 'editUser',
      component: editUser
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js